/* 维护边界：Impact 购物车适配；单标签页串行同步。没有后台权限，不改价格，不包装全局 fetch。 */
(() => {
  if (window.BixdoGifts) return;
  const engine = window.BixdoGiftEngine;
  const root = window.Shopify?.routes?.root || '/';
  let tail = Promise.resolve(), pending = 0, last = null;
  function reflectActive() {
    const active = !!last && (last.cart.items.some(engine.isGift) || last.rules.some(r => engine.gifts(r.promotion).length));
    document.documentElement.toggleAttribute('data-bixdo-gift-active', active);
  }
  async function request(path, body) {
    const response = await fetch(`${root}${path}`, {
      ...(body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : {}),
      cache: 'no-store', signal: AbortSignal.timeout(15000)
    });
    if (!response.ok) throw new Error(`Gift cart request failed: ${response.status}`);
    return response;
  }
  async function snapshot() {
    const response = await request(`cart?section_id=bixdo-gift-cart&_=${Date.now()}`);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const node = html.querySelector('[data-bixdo-gift-snapshot]');
    if (!node) throw new Error('Gift snapshot unavailable');
    const data = JSON.parse(node.textContent);
    if (!Array.isArray(data.cart?.items) || !Array.isArray(data.rules)) throw new Error('Invalid gift snapshot');
    last = data;
    reflectActive();
    return data;
  }
  async function publish(cart) {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
    document.querySelectorAll('[data-bixdo-cart-section]').forEach(n => sections.push(n.dataset.bixdoCartSection));
    const ids = [...new Set(sections)].slice(0, 5);
    if (ids.length) {
      cart.sections = await (await request(`cart?sections=${encodeURIComponent(ids.join(','))}&_=${Date.now()}`)).json();
      if (ids.some(id => !cart.sections[id])) throw new Error('Cart rendering failed');
      document.querySelectorAll('[data-bixdo-cart-section]').forEach(node => {
        const html = new DOMParser().parseFromString(cart.sections[node.dataset.bixdoCartSection], 'text/html');
        const next = html.querySelector('[data-bixdo-cart-section]');
        if (next) node.replaceWith(next);
      });
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', bixdoGiftSync: true, cart } }));
    }
    reflectActive();
  }
  async function reconcile() {
    let data = await snapshot();
    let plan = engine.plan(data.cart, data.rules);
    let changed = false;
    // 先移除/调整旧 line，再读取新 key。折扣重新分配可能改变 line key。
    // change.js 校验库存；update.js 调高已有行时不保证校验库存。
    // 每次使用新快照中的 key；限定次数，避免折扣拆行造成无限修复。
    const limit = data.cart.items.length + 1;
    for (let step = 0; Object.keys(plan.updates).length && step < limit; step++) {
      const [id, quantity] = Object.entries(plan.updates)[0];
      await request('cart/change.js', { id, quantity });
      changed = true;
      data = await snapshot();
      plan = engine.plan(data.cart, data.rules);
    }
    if (Object.keys(plan.updates).length) throw new Error('Cart did not settle');
    if (plan.missing.length) {
      await request('cart/add.js', { items: plan.missing });
      changed = true;
      data = await snapshot();
    }
    plan = engine.plan(data.cart, data.rules);
    const settled = !Object.keys(plan.updates).length && !plan.missing.length;
    if (!settled) throw new Error('Gift quantity mismatch');
    // Quantity relationships only. Shopify owns discount eligibility and prices.
    if (changed) await publish(data.cart);
    return data.cart;
  }
  function exclusive(task) {
    pending++;
    const run = tail.then(task);
    tail = run.catch(() => {}).finally(() => { pending--; });
    return run;
  }
  const sync = () => exclusive(reconcile);
  window.BixdoGifts = { sync, exclusive, reconcile, publish, get busy() { return pending > 0; } };
  const needed = () => relevant() || !!document.querySelector('[data-bixdo-gift-needed="true"]');
  document.addEventListener('cart:change', event => {
    const payload = event.detail?.cart;
    const incoming = payload?.items?.some(engine.isGift) || Object.values(payload?.sections || {}).some(html => html?.includes('data-bixdo-gift-needed="true"'));
    if (!event.detail?.bixdoGiftSync && (incoming || needed())) sync().catch(() => {});
  });
  document.addEventListener('cart:refresh', () => { if (needed()) sync().catch(() => {}); });
  window.addEventListener('pageshow', event => { if (event.persisted && needed()) sync().catch(() => {}); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible' && last?.cart.items.some(engine.isGift)) sync().catch(() => {}); });
  // 接管有活动购物车的数量控件，避免 Impact 在赠品同步前 reload。
  function relevant() { return last?.cart.items.some(engine.isGift) || last?.rules.some(r => engine.gifts(r.promotion).length); }
  function changeQuantity(key, quantity) {
    return exclusive(async () => {
      const data = await snapshot();
      const line = data.cart.items.find(i => i.key === key);
      if (!line || engine.isGift(line)) return reconcile();
      await request('cart/change.js', { id: key, quantity });
      const cart = await reconcile();
      await publish(cart);
    }).catch(() => {});
  }
  document.addEventListener('change', event => {
    const input = event.target.closest?.('line-item-quantity input[data-line-key]');
    if (!input || !relevant()) return;
    event.stopImmediatePropagation();
    const quantity = Number(input.value);
    if (!Number.isSafeInteger(quantity) || quantity < 0 || pending) { input.value = input.defaultValue; return; }
    changeQuantity(input.dataset.lineKey, quantity);
  }, true);
  document.addEventListener('click', event => {
    const remove = event.target.closest('line-item-quantity a[href*="/cart/change"]');
    if (remove && relevant()) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!pending) changeQuantity(new URL(remove.href).searchParams.get('id'), 0);
      return;
    }
    const checkout = event.target.closest('a[href]');
    if (checkout && needed() && /\/checkout\/?$/.test(new URL(checkout.href).pathname)) {
      event.preventDefault(); event.stopImmediatePropagation();
      sync().then(() => location.assign(checkout.href)).catch(() => {});
    }
  }, true);
  let approvedForm = null;
  document.addEventListener('submit', event => {
    if (event.target === approvedForm) { approvedForm = null; return; }
    if (event.submitter?.name !== 'checkout' || !needed()) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const form = event.target, submitter = event.submitter;
    sync().then(() => {
      const currentSubmitter = submitter.isConnected ? submitter : document.querySelector('button[name="checkout"], input[name="checkout"]');
      const currentForm = currentSubmitter?.form || (form.isConnected ? form : null);
      if (!currentForm) throw new Error('Checkout form changed');
      approvedForm = currentForm;
      currentForm.requestSubmit(currentSubmitter);
    }).catch(() => {});
  }, true);
  // 页面加载校准一次；无定时轮询。Checkout 前始终重新验证。
  if (needed()) sync().catch(() => {});
})();
